module.exports = __webpack_public_path__ + "img/float1.77ec0a60.svg";